import { render, staticRenderFns } from "./OrgUnitSelectorSearch.vue?vue&type=template&id=a5af59a4&scoped=true&lang=html&"
import script from "./OrgUnitSelectorSearch.vue?vue&type=script&lang=js&"
export * from "./OrgUnitSelectorSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5af59a4",
  null
  
)

export default component.exports